// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__12rGI","resendEmailButton":"styles_resendEmailButton__25taj"};